export const API_URL = import.meta.env["VITE_API_URL"] ?? "http://localhost:4000";
export const TRPC_URL = `${API_URL}/api/trpc`;
